import { APP_ENV } from '../constants/app/environment';

export const envConfig = {
  appEnv: process.env.NEXT_PUBLIC_APP_ENV,
};

export const isProd = process.env.NEXT_PUBLIC_APP_ENV === APP_ENV.PRODUCTION;

const requiredEnvVars = ['NEXT_PUBLIC_APP_ENV'] as const;

for (const key of requiredEnvVars) {
  if (!process.env[key]) {
    console.warn(`[DZap] Missing environment variable: ${key}`);
  }
}
